import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { getArticlesByCategory } from "@/utils/content";

export default function CategoryShortcuts() {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="text-xl font-bold text-foreground-950 md:text-2xl">内容分类</h2>
          <p className="mt-1 text-sm text-foreground-500">四大板块，覆盖音乐、影视、时尚与潮流文化</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((c) => {
          const count = getArticlesByCategory(c.slug).length;
          return (
            <Link
              key={c.slug}
              to={`/category/${c.slug}`}
              className="group relative h-44 cursor-pointer overflow-hidden rounded-lg"
            >
              <img
                src={c.cover}
                alt={c.name}
                title={`${c.name}资讯 - 噜噜社`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-secondary-950/85 via-secondary-950/30 to-transparent" />
              <div className="absolute inset-x-0 bottom-0 p-4">
                <div className="flex items-center gap-2">
                  <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${c.icon} text-lg`} />
                  </span>
                  <span className="text-lg font-bold text-background-50">{c.name}</span>
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-background-200">
                    {c.enName}
                  </span>
                </div>
                <p className="mt-2 text-xs text-background-100/90">{c.tagline}</p>
                <p className="mt-1 text-[11px] text-primary-300">共 {count} 篇内容 · 点击进入 →</p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}